export default __webpack_public_path__ + "static/media/firstAid.02244176.svg";